import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { ArrowLeft, Building, Mail, Phone, MapPin, User, FileText, ExternalLink } from 'lucide-react';

const Impressum = ({ onClose }) => {
  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
      <Card className="w-full max-w-3xl max-h-[90vh] overflow-y-auto">
        <CardHeader className="sticky top-0 bg-white border-b z-10">
          <div className="flex items-center justify-between">
            <CardTitle className="text-2xl font-bold text-gray-900 flex items-center">
              <Building className="h-6 w-6 mr-2 text-blue-600" />
              Impressum
            </CardTitle>
            <Button variant="ghost" onClick={onClose}>
              <ArrowLeft className="h-4 w-4 mr-2" />
              Schließen
            </Button>
          </div>
        </CardHeader>
        <CardContent className="p-6 space-y-6 text-sm leading-relaxed">
          
          {/* Angaben gemäß TMG */}
          <section>
            <div className="bg-blue-50 p-6 rounded-lg">
              <h3 className="font-semibold text-blue-900 mb-4 flex items-center">
                <User className="h-5 w-5 mr-2" />
                Elektrotechnik Wegele
              </h3>
              <div className="text-blue-800 space-y-2">
                <p className="text-lg font-semibold">Inhaber: Alexander Wegele</p>
                <p>Wurzbergstraße 3</p>
                <p>86934 Reichling</p>
                <p>Deutschland</p>
              </div>
            </div>
          </section>

          {/* Kontaktdaten */}
          <section>
            <h3 className="text-xl font-semibold text-gray-900 mb-4 flex items-center">
              <MapPin className="h-5 w-5 mr-2" />
              Kontakt
            </h3>
            <div className="space-y-3 text-gray-700">
              <p className="flex items-center">
                <Phone className="h-4 w-4 mr-3 text-gray-500" />
                0162 294 69 61
              </p>
              <p className="flex items-center">
                <Mail className="h-4 w-4 mr-3 text-gray-500" />
                office@elektrotechnik-wegele.de
              </p>
            </div>
          </section>

          {/* Rechtliche Angaben */}
          <section>
            <h3 className="text-xl font-semibold text-gray-900 mb-4 flex items-center">
              <FileText className="h-5 w-5 mr-2" />
              Rechtliche Angaben
            </h3>
            <div className="space-y-3 text-gray-700">
              <p><strong>Rechtsform:</strong> Einzelunternehmen</p>
              <p><strong>Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG:</strong> DE453485809</p>
              <p><strong>Gesetzliche Berufsbezeichnung:</strong> Staatlich geprüfter Elektrotechniker</p>
              <p><strong>Verliehen in:</strong> Deutschland</p>
            </div>
          </section>

          {/* Handwerkskammer */}
          <section>
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Handwerkskammer / Eintragung in die Handwerksrolle</h3>
            <div className="text-gray-700 space-y-2">
              <p>Handwerkskammer für München und Oberbayern</p>
              <p><strong>Betriebsnummer:</strong> 7236102</p>
            </div>
          </section>

          {/* Inhaltlich Verantwortlich */}
          <section>
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Inhaltlich verantwortlich gemäß § 18 Abs. 2 MStV</h3>
            <div className="text-gray-700">
              <p>Alexander Wegele</p>
              <p>Wurzbergstraße 3, 86934 Reichling</p>
            </div>
          </section>

          {/* Haftung für Inhalte */}
          <section>
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Haftung für Inhalte</h3>
            <div className="text-gray-700 space-y-3">
              <p>
                Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den 
                allgemeinen Gesetzen verantwortlich.
              </p>
              <p>
                Nach §§ 8 bis 10 TMG sind wir jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde 
                Informationen dauerhaft zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige 
                Tätigkeit hinweisen.
              </p>
              <p>
                Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen 
                Gesetzen bleiben hiervon unberührt.
              </p>
            </div>
          </section>

          {/* Haftung für Links */}
          <section>
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Haftung für Links</h3>
            <div className="text-gray-700 space-y-3">
              <p>
                Unsere Website enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben.
              </p>
              <p>
                Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
              </p>
              <p>
                Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
              </p>
            </div>
          </section>

          {/* Urheberrecht */}
          <section>
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Urheberrecht</h3>
            <div className="text-gray-700 space-y-3">
              <p>
                Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen 
                Urheberrecht.
              </p>
              <p>
                Beiträge Dritter sind als solche gekennzeichnet.
              </p>
            </div>
          </section>

          {/* Online-Streitbeilegung */}
          <section>
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Online-Streitbeilegung</h3>
            <div className="text-gray-700 space-y-3">
              <p>
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
              </p>
              <p className="flex items-center">
                <ExternalLink className="h-4 w-4 mr-2 text-gray-500" />
                <a 
                  href="https://ec.europa.eu/consumers/odr/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:underline"
                >
                  https://ec.europa.eu/consumers/odr/
                </a>
              </p>
              <p>
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </div>
          </section>

        </CardContent>
      </Card>
    </div>
  );
};

export default Impressum;